export interface ICardStackProps {
    numOfPlayerCards: number;
    className: string;
    isOpponentStack?: boolean;
}

export function CardStack(props: ICardStackProps): JSX.Element {
    const { numOfPlayerCards, className, isOpponentStack } = props;

    // If less than 4 cards, show same number of cards
    // If 4 <= 6 cards, show 3 cards
    let numOfPlayerCardsToShow = 0;
    switch (numOfPlayerCards) {
        case 0:
        case 1:
        case 2:
        case 3:
            numOfPlayerCardsToShow = numOfPlayerCards;
            break;
        case 4:
        case 5:
        case 6:
            numOfPlayerCardsToShow = 3;
            break;
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
            numOfPlayerCardsToShow = 4;
            break;
        default:
            numOfPlayerCardsToShow = 5;
            break;
    }

    const cardStackArray = [];

    const translateY = isOpponentStack ? 4 : 7;

    for (let i = 0; i < numOfPlayerCardsToShow - 1; i++) {
        cardStackArray.push(
            <div
                key={i + 1}
                className={className}
                style={{
                    transform: `translateY(${i * translateY}px) scale(${1 - i * 0.02})`,
                    zIndex: numOfPlayerCardsToShow - i,
                }}
            />
        );
    }

    return (
        <>
            {cardStackArray}
        </>
    );
}